import { CustomizedDetailedUser } from '../hooks/useUserById';
import { roles } from '../model/types';
import { CurrentUserStore } from '../store/childStore/currentUserStore';
import { isSSR } from './helpers';
import getStore from './store/getStore';

// TODO SSL certificate: change [0] => [1]
export const getTenantIdFromHostName: (hostName: string) => string = (hostName) => hostName.split('.')[0];

export const getTenantId = (): string | null => (isSSR() ? null : getTenantIdFromHostName(window.location.host));

// TODO cagri: replace this with a proper solution
export const getCurrentTicketKey = (): string | null => getStore().TabStore.selectedTabKey; //FIXME delete

const checkIfUserIs =
    (roleToCheck: roles) =>
    (roleParam: roles): boolean => {
        if (!roleToCheck) {
            // console.debug('roleToCheck parameter is empty, will return false');
            return false;
        }

        if (!roleParam) {
            // console.debug('roleParam parameter is empty, will return false');
            return false;
        }

        return roleParam === roleToCheck;
    };
export const isAdmin = checkIfUserIs('ROLE_ADMIN');
export const isAgent = checkIfUserIs('ROLE_AGENT');
export const isAdminOrAgent = (role: roles): boolean => {
    if (isAdmin(role)) return true;
    return isAgent(role);
};
export const isEndUser = checkIfUserIs('ROLE_END_USER');

/**
 * Check to current user's edit permission for target user.
 *
 * Edit Permission rules:
 *
 * -Owner has unlimited edit permission.
 *
 * -Admin has edit permission for agent, end-user and self.
 *
 * -Agent has edit permission for end-user and self.
 *
 * -End-user has edit permissin for self.
 *
 * TODO: we need a 'OWNER' role instead of using ownerId
 *
 * @param targetUser
 * @param ownerId
 * @returns boolean
 */
export const isCurrentUserHavePermissionToEditTargetUser = (
    targetUser: CustomizedDetailedUser,
    ownerId: number
): boolean => {
    const cUser = getCurrentUser();
    if (cUser.id === ownerId) return true;
    else if (
        isAdmin(cUser.role) &&
        (cUser.id === targetUser?.id || isAgent(targetUser?.role?.authority) || isEndUser(targetUser?.role?.authority))
    )
        return true;
    else if (isAgent(cUser.role) && (cUser.id === targetUser?.id || isEndUser(targetUser?.role?.authority)))
        return true;
    else if (isEndUser(cUser.role) && cUser.id === targetUser?.id) return true;
    else return false;
};
// with following methods, it is intended to acces to the mobxStore outside of the components, easily.
// Thus, if you're not sure what you're doing, please use store-hooks in src/store/RootStoreContext.tsx to access mobxStore from the inside of the components;
export const getCurrentUser = (): CurrentUserStore => getStore().CurrentUserStore;
export const getCurrentUserEmail = (): string | null => getCurrentUser()?.email;
export const getCurrentUserPhone = (): string | null => getCurrentUser()?.phone;
export const getCurrentUserFullName = (): string | null => getCurrentUser()?.fullName;
export const getCurrentUserRole = (): roles | null => getCurrentUser()?.role;
